<template lang="pug">
AppDialog.leaderboard-dialog(
  :key="show"
  append-to-body
  :show="show"
  :size="size"
  @close="closeDialog"
)
  InsightsLeaderboardWidget.insights-leaderboard-dialog(
    title-classes="title"
    scrollable
    :has-dialog="false"
  )
    template(#action)
      button.close(
        type="button"
        data-dismiss="modal"
        aria-hidden="true"
        @click="closeDialog"
      )
        i.hi.hi-close.hi-10
</template>

<script>
import AppDialog from '~/components/AppDialog.vue';
import InsightsLeaderboardWidget from '~/components/insights/InsightsLeaderboardWidget.vue';

export default {
  name: 'InsightsLeaderboardDialog',
  components: {
    AppDialog,
    InsightsLeaderboardWidget,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    size: {
      type: String,
      default: 'large',
    },
  },
  emits: ['close'],
  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
